import vuetify from "@/plugins/vuetify";
import vueTheMask from "@/plugins/vue-the-mask";
import vueCookies from "@/plugins/vue-cookies"

export default {
    vuetify,
    vueTheMask,
    vueCookies
}
